/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (resourceConnectId) => (dispatch) => {
    //dispatch({
    //    type: actions.RESOURCES_REQUEST,
    //});

    return cecSdk
        .resourceConnect(resourceConnectId)
        .sync()
        .then((resourceConnect) => {
            //dispatch({
            //    type: actions.RESOURCES_REQUEST_SUCCESS,
            //});
            //dispatch(receiveResources(resources));
            return resourceConnect;
        });
};
